module.exports = __webpack_public_path__ + "media/mascot/mascot4-432f652f.png";